import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { ISelectOption } from '../../../../../common/types/select'
import { MATCHING_PROFILES_API } from './consts'
import { ApiResponse } from './response.types'
import { MatchingProfile, ProfileListParams, ProfileSchema } from './types'
import { ProfileWriteBody } from './requests.types'

const base = `${API_URL}${MATCHING_PROFILES_API}`

// Schema is fetched once on entering the section and cached — matching owns the
// field contract (CPAYMENT-1643).
export const getSchema = () => axios.get<ApiResponse<ProfileSchema>>(`${base}/schema`)

export const listProfiles = (params: ProfileListParams) =>
  axios.get<ApiResponse<MatchingProfile[]>>(base, { params })

export const createProfile = (body: ProfileWriteBody) =>
  axios.post<ApiResponse<MatchingProfile>>(base, body)

export const updateProfile = (id: number, body: ProfileWriteBody) =>
  axios.put<ApiResponse<MatchingProfile>>(`${base}/${id}`, body)

export const setProfileActive = (id: number, is_active: boolean) =>
  axios.patch<ApiResponse<MatchingProfile>>(`${base}/${id}/active`, { is_active })

// Hard delete (CPAYMENT-1723) — the row disappears from the DB. Turning a profile
// off without losing it stays on setProfileActive.
export const deleteProfile = (id: number) => axios.delete<ApiResponse<null>>(`${base}/${id}`)

// Merchants are backend-owned — the main merchant select AND every isolation
// int_list are populated from this backend lookup; only IDs are sent onward.
export const getMerchantLookup = () =>
  axios.get<ApiResponse<ISelectOption<number>[]>>(`${API_URL}/api/merchant/lookup`)

// Справочник банков — источник значений фильтра `banks` (CPAYMENT-1748). В профиль
// уходит только код (`value` = bank.code): матчинг сравнивает с ним банк выплаты.
// Префикс /api/internal обязателен: preflight с x-api-key разрешён в nelmio_cors
// только для перечисленных префиксов, вне их админка ловит ошибку CORS.
export const getBankLookup = () =>
  axios.get<ApiResponse<ISelectOption<string>[]>>(`${API_URL}/api/internal/bank/lookup`)

// Справочник платёжных методов — источник значений фильтра `payment_method`
// (CPAYMENT-1695). В профиль уходит id метода (`value`), матчинг сравнивает с ним
// метод тикета: выплаты на PAYOUT, депозита на PAYMENT. Тот же справочник уже питает
// разделы «Платёжные адаптеры» и «Реквизиты».
export const getPaymentMethodLookup = () =>
  axios.get<ApiResponse<ISelectOption<number>[]>>(`${API_URL}/api/payment-method/lookup`)
